export const SET_CONTENT_TEMPLATES = 'content-template/set-content-templates';
export const SET_CONTENT_TEMPLATE_FILTER = 'content-template/set-content-template-filter';
export const SET_CONTENT_TEMPLATE_SEARCH_ATTRIBUTE = 'content-template/set-content-template-search-attribute';
export const SET_CONTENT_TEMPLATE_SEARCH_KEYWORD = 'content-template/set-content-template-search-keyword';
export const SET_CONTENT_TEMPLATE_OPENED = 'content-template/set-content-template-opened';
export const CLEAR_CONTENT_TEMPLATE_OPENED = 'content-template/clear-content-template-opened';
export const SET_CONTENT_TEMPLATE_DICTIONARY = 'content-template/set-content-template-dictionary';
export const CLEAR_CONTENT_TEMPLATE_DICTIONARY = 'content-template/clear-content-template-dictionary';
